import { Dialog as KendoDialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import { ApiErrorComponent } from '../../components/api-error.component';
import { planApiKeyStore } from '../../api/plan-api-key-store';
import { useSaveData } from '../../hooks/useSaveData';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface PlanRequestArgs {
    projectID?: number;
    officeID?: number;
    unitID?: number;
    planID?: number;
}

interface ConfirmDeleteDialog {
    isPlanLoading: boolean;
    refetching: () => void;
    onClosed: () => void;
    planRequestArgs: PlanRequestArgs;
}
export const ConfirmDeletePlanDialog = ({ planRequestArgs, isPlanLoading, refetching, onClosed }: ConfirmDeleteDialog) => {

    const { isLoading, isError, error, mutateAsync } = useSaveData<any>(planApiKeyStore.removeMapPlan());

    const handleDeletePlan = async () => {
        await mutateAsync({ data: planRequestArgs });
        refetching();
        onClosed();
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <KendoDialog className="modalpopup" title={'CONFIRM DELETE'} onClose={onClosed}>
            <div>
                <div style={{ padding: '25px 50px' }}>
                    <div>Are you sure you want to permanently delete?</div>
                    <LoadingIndicator isLoading={isLoading} />
                    <ApiErrorComponent isError={isError} errorRespnse={error} />
                </div>
            </div>
            <DialogActionsBar>
                <div className=" spaceBetween">
                    <button className="btn btn-sm btn-default btn-lightGrey" onClick={onClosed} autoFocus>
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-danger btn-delete"
                        style={{
                            backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#FF8A8A',
                            color: isReadOnlyPermission ? 'black' : '#fff'
                        }}
                        type="button"
                        onClick={handleDeletePlan}
                        disabled={isPlanLoading || isReadOnlyPermission}
                    >
                        Delete
                    </button>
                </div>
            </DialogActionsBar>
        </KendoDialog>
    )
}